// import Cards from './cards'
import Dialogs from './dialogs'

export default function () {
	// Cards()
	Dialogs()
}
